import { StoreType } from './TypeDefinitions';

export enum AMServerType {
	ServerType_Unknown = 'AM_SERVER_TYPE_UNKNOWN',
	ServerType_Cloud = 'SERVER_TYPE_CLOUD',
	ServerType_SF = 'AM_SERVER_TYPE_STOREFRONT',
	ServerType_AG_Basic = 'AM_SERVER_TYPE_GATEWAY_BASIC',
	ServerType_AG_Advanced = 'AM_SERVER_TYPE_GATEWAY_ADVANCED',
	ServerType_Gateway = 'AM_SERVER_TYPE_GATEWAY',
}

export enum GatewayEdition {
	Gateway_Edition_Standard = 'GATEWAY_EDITION_STANDARD',
	Gateway_Edition_Advanced = 'GATEWAY_EDITION_ADVANCED',
	Gateway_Edition_Enterprise = 'GATEWAY_EDITION_ENTERPRISE',
	Gateway_Edition_None = 'GATEWAY_EDITION_NONE',
}

export enum GatewayAuthenticationType {
	Gateway_AuthType_RSA = 'GATEWAY_AUTH_TYPE_RSA',
	Gateway_AuthType_None = 'GATEWAY_AUTH_TYPE_NONE',
	Gateway_AuthType_Domain = 'GATEWAY_AUTH_TYPE_DOMAIN',
	Gateway_AuthType_Domain_And_RSA = 'GATEWAY_AUTH_TYPE_DOMAIN_AND_RSA',
	Gateway_AuthType_SMS = 'GATEWAY_AUTH_TYPE_SMS',
	Gateway_AuthType_Gateway_Knows = 'GATEWAY_AUTH_TYPE_GATEWAY_KNOWS',
}

/**
 * Different kinds of errors that can be thrown from auth to AccountConfig via window.gatewayAuthenticatedFetchWrapper,
 * any new error if required specifically can be added here
 */
export enum AuthenticatedFetchErrors {
	GatewaySessionError = 'GatewaySessionError',
	AuthenticationError = 'AuthenticationError',
}

export enum GatewayRewriteMode {
	SG = 'sg',
	CVPN = 'entcvpn',
}

export class GatewayInfo {
	constructor() {
		this.Edition = GatewayEdition.Gateway_Edition_None;
		this.AuthenticationType = GatewayAuthenticationType.Gateway_AuthType_None;
	}

	public Edition: GatewayEdition;
	public AuthenticationType: GatewayAuthenticationType;
	public LogonPointUrl: string;
	public FriendlyName: string;
	public RewriteMode: GatewayRewriteMode;
	public pwcount: number;
}

export class ServerInfo {
	constructor() {
		this.serverType = StoreType.Unknown;
	}
	public serverType: StoreType;
	public gatewayInfo: GatewayInfo;
}

export interface AuthenticatedFetchErrorJSON {
	error: {
		message: string;
		type: AuthenticatedFetchErrors;
	};
}
